export default __webpack_public_path__ + "static/media/20220721-093039.5a955672.jpg";